var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24967 15.8335C6.90245 15.8335 5.7462 15.396 4.78092 14.521C3.81565 13.646 3.33301 12.5557 3.33301 11.2502C3.33301 9.94461 3.81565 8.85433 4.78092 7.97933C5.7462 7.10433 6.90245 6.66683 8.24967 6.66683H13.4997L11.333 4.50016L12.4997 3.3335L16.6663 7.50016L12.4997 11.6668L11.333 10.5002L13.4997 8.3335H8.24967C7.37467 8.3335 6.61426 8.61127 5.96842 9.16683C5.32259 9.72238 4.99967 10.4168 4.99967 11.2502C4.99967 12.0835 5.32259 12.7779 5.96842 13.3335C6.61426 13.8891 7.37467 14.1668 8.24967 14.1668H14.1663V15.8335H8.24967Z",
    fill: "white"
  }))));
};
export { SvgRedo as ReactComponent };
export default __webpack_public_path__ + "assets/30780b49.svg";